export default "__VITE_ASSET__B4Nvbi5F__"